import React from "react";

const PreviewMessageEnglishNotificationCenter = ({ englishValues }) => {
  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="self-stretch px-5 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch justify-start text-zinc-800 text-xs font-semibold font-['Montserrat']">
          Mobile Preview
        </div>
        <div className="self-stretch p-2.5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-300/90 inline-flex justify-start items-start gap-2">
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-1.5">
            <div className="self-stretch inline-flex justify-end items-center gap-7">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
                <div className="inline-flex justify-start items-center gap-2">
                  <div className="justify-center text-sky-900 text-xs font-semibold font-['Montserrat']">
                    {englishValues.titleEn}
                  </div>
                </div>
                <div className="self-stretch justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {englishValues.bodyEn}
                </div>
              </div>
              <div className="w-6 inline-flex flex-col justify-start items-start gap-0.5">
                <img
                  src="/images/arrow-right.svg"
                  alt="arrow-right"
                  className="w-5 h-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch px-5 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch justify-start text-zinc-800 text-xs font-semibold font-['Montserrat']">
          {" "}
          Web Preview
        </div>
        <div className="self-stretch p-2.5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-300/90 inline-flex justify-start items-start gap-2">
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-1.5">
            <div className="self-stretch inline-flex justify-start items-start gap-2">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
                <div className="inline-flex justify-start items-center gap-2">
                  <img src="/images/notification.svg" alt="notification-icon" />
                  <div className="justify-center text-sky-900 text-xs font-semibold font-['Montserrat']">
                    {englishValues.titleEn}
                  </div>
                </div>
                <div className="self-stretch justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {englishValues.bodyEn}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewMessageEnglishNotificationCenter;
